<p-dialog modal="true" [(visible)]="showRelatedModal" [closable]="false" styleClass="atlas-dialog-m"
  [focusOnShow]="false" [contentStyle]="{ 'max-height': '75vh' }">
  <ng-template pTemplate="header">
    <div>
      <h4>
        <span style="font-weight: normal !important">
          {{ 'profiles.relate-existing.label' | translate | titlecase }}
          <span style="font-weight: bold">{{ profile ? profile.ReportName : '' }}</span>
          <span style="color: #999999"> ({{ profile ? profile.ProfileId : 0 }})</span>
        </span>
      </h4>
    </div>
  </ng-template>
  <div style="height: 500px">
    <div [hidden]="selectedProfile.ProfileId > 0">
      <div class="profile-quicksearch-box">
        <label>
          {{ 'profiles.relate-existing.search-text' | translate }}
        </label>
        <wl-profile-quicksearch (searchComplete)="showResults($event)"></wl-profile-quicksearch>
      </div>
      <div class="profile-quicksearch-results">
        <wl-profile-results-grid (onProfileSelected)="selectProfile($event)"></wl-profile-results-grid>
      </div>
    </div>
    <div [hidden]="selectedProfile.ProfileId === 0">
      <wl-profile-edit [preventLoad]="true" [profileId]="selectedProfile.ProfileId" [relatedProfileId]="profileId"
        [selectedTab]="'relationship'" [hideSaveButtons]="true"></wl-profile-edit>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="close()">{{ 'common.cancel' | translate |
      uppercase }}</button>
    <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="close()"
      [hidden]="selectedProfile.ProfileId > 0">
      {{ 'profiles.relate-existing.create-new' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary ml-10" (click)="save()"
      [hidden]="selectedProfile.ProfileId === 0">
      {{ 'common.save' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>